// SearchPage.tsx

import QueryInputBox from './QueryInputBox';


/**
 * SearchPage Component
 * Renders the input box and handles search logic
 */
const SearchPage = () => {
  return (
    <div className=" bg-[#FDFDFD] px-20">
       
      <QueryInputBox />
    </div>
  );
};

export default SearchPage;
